// import ContactInfo from '../SizerScreens/ContactInfo';
// import EnvironmentDetails from '../SizerScreens/EnvironmentDetails';
// import OtherEnvironmentDetails from '../SizerScreens/OtherEnvironmentDetails';
import HadoopServices from '../SizerScreens/HadoopServices'
import ExtranodeConfig from '../SizerScreens/ExtraNodesConfiguration'
import HardwareandLicense from '../SizerScreens/HardWareAndLicenses'
import Functions from '../SizerScreens/Functions'
import BlueData from '../SizerScreens/BlueData'
import HostServerConfiguration from '../SizerScreens/HostServerConfiguration'
import Growth from '../SizerScreens/Growth'


export const sizerScreens = [        
         { path: '/Build/Functions',
          component: Functions,        
          label: 'Functions',
          isenabled: true,
          type:'BigData'          
         },    
        { path: '/Build/HadoopServices',
          component: HadoopServices,        
          label: 'Licenses and Support',
          isenabled: true,
          type:'BigData'          
        },
        { path: '/Build/ExtraNodesConfiguration',
          component: ExtranodeConfig,        
          //label: 'Extra Nodes Configuration',
          label: 'Master and Gateway Nodes Configuration',
          isenabled: true,
          type:'BigData'          
        },  
	{
    path: '/Build/Growth',
    component: Growth,
    label: 'Growth',
    isenabled: true,
    type: 'BigData'
  },
        { path: '/Build/Infrastructure',
          component: HardwareandLicense,        
          label: 'Infrastructure',
          isenabled: true,
          type:'BigData'          
        },
        { path: '/Build/HPEEzmeralRuntimeEnterprise',
          component: BlueData,        
          label: 'Ezmeral Runtime Enterprise Workload Requirements',
          isenabled: true,
          type:'BlueData'          
        },
         { path: '/Build/HostServerConfiguration',
          component: HostServerConfiguration,        
          label: 'Gateway, Controller and Master Host Configurations',
          isenabled: true,
          type:'BlueData'          
        },{ path: '/Build/HadoopServices',
          component: HadoopServices,        
          label: 'Licenses and Support',
          isenabled: true,
          type:'BlueData'          
        },
        { path: '/Build/Growth',
          component: Growth,        
          label: 'Growth',
          isenabled: true,
          type:'BlueData'          
        },
        { path: '/Build/Infrastructure',
          component: HardwareandLicense,        
          label: 'Infrastructure',
          isenabled: true,
          type:'BlueData'          
        }
    ];

/*    var temp = [
         { path: '/Build/HadoopServices',
          component: HadoopServices,        
          label: 'Licenses and Support',
          isenabled: true,
          type:'BlueData'          
        },  
        { path: '/Build/Infrastructure',
          component: HardwareandLicense,        
          label: 'Infrastructure',
          isenabled: true,
          type:'BlueData'          
        }
    ]
*/



// WEBPACK FOOTER //
// ./src/SizerUI/SizerConfig/RouteConfig.js